function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "2D65061A-743E-4A49-9CE7-8E048D8EFC18@2x");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "desktop"
}, /*#__PURE__*/React.createElement("g", {
  id: "cadastrar-a\\xE7\\xE3o",
  transform: "translate(-657.000000, -831.000000)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M677.182,832.648h-0.545V831h-2.182v1.648h-10.637V831h-2.182v1.648h-0.818c-2.109,0-3.818,1.722-3.818,3.846 v15.66c0,2.123,1.709,3.846,3.818,3.846h16.363c2.109,0,3.818-1.723,3.818-3.846v-15.66 C681,834.37,679.291,832.648,677.182,832.648L677.182,832.648z M660.818,834.846h0.818v1.648h2.182v-1.648h10.637v1.648h2.182 v-1.648h0.545c0.904,0,1.637,0.738,1.637,1.648v2.472h-19.637v-2.472C659.182,835.584,659.915,834.846,660.818,834.846z  M677.182,853.803h-16.363c-0.904,0-1.637-0.738-1.637-1.648v-10.989h19.637v10.989 C678.818,853.064,678.086,853.803,677.182,853.803z"
})));

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "25px",
    viewBox: "0 0 24 25",
    enableBackground: "new 0 0 24 25",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar.3cf3113d.svg";
export { ForwardRef as ReactComponent };